  document.addEventListener("DOMContentLoaded", function () {
    const heroBanner = document.querySelector(".hero-banner");
    if (!heroBanner) return;

    const banners = heroBanner.querySelectorAll(".hero-banner-item");
    const bullets = heroBanner.querySelectorAll(".hero-bullet");
    let current = 0;
    const transitionTimeAttr = heroBanner.getAttribute("data-transition-time");
    const intervalTime = parseInt(transitionTimeAttr, 10) || 5000; // tempo em milissegundos
    let interval;

    function showSlide(index) {
      banners.forEach((banner, i) => {
        banner.classList.toggle("active", i === index);
        bullets[i]?.classList.toggle("active", i === index);
      });
      current = index;
    }

    function nextSlide() {
      const next = (current + 1) % banners.length;
      showSlide(next);
    }

    function startAutoSlide() {
      stopAutoSlide(); // evita múltiplos intervalos
      interval = setInterval(nextSlide, intervalTime);
    }

    function stopAutoSlide() {
      clearInterval(interval);
    }

    // Clique nos bullets
    bullets.forEach((bullet, index) => {
      bullet.addEventListener("click", (e) => {
        e.preventDefault();
        showSlide(index);
        startAutoSlide(); // 🔁 reseta o tempo ao clicar
      });
    });

    // Clique nas setas prev/next
    const prevArrow = heroBanner.querySelector(".hero-nav-arrow.prev");
    const nextArrow = heroBanner.querySelector(".hero-nav-arrow.next");

    if (prevArrow) {
      prevArrow.addEventListener("click", (e) => {
        e.preventDefault();
        const prev = (current - 1 + banners.length) % banners.length;
        showSlide(prev);
        startAutoSlide(); // 🔁 reseta o tempo ao clicar
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener("click", (e) => {
        e.preventDefault();
        nextSlide();
        startAutoSlide(); // 🔁 reseta o tempo ao clicar
      });
    }

    // Inicia o auto slide
    if (banners.length > 1) {
      startAutoSlide();
    }
  });